import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Axios from 'axios';
import { message, Form } from 'antd';

import { appConstant, apiUrl } from '@constants';
import { getCroppedImg } from '@constants/canvautils';
import getBase64 from '@sharedComponent/base-64';
import { getAuthToken, getAuthKey } from '@helpers';
import ActionsApp from '@sharedComponent/app-action-reducer/action';
import Selectors from '@sharedComponent/app-action-reducer/selectors';
import { ProfilePresentational } from './profile-presentational';

const ProfileFunctional = ({ params, userDetails, removeUser }) => {
	const history = useHistory();
	const [formRef] = Form.useForm();
	const [formChangePasswordRef] = Form.useForm();

	const handlechange = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};

	const [profilevisible, setProfileVisible] = useState(false);

	const [state, setState] = useState({
		crop: { x: 0, y: 0 },
		zoom: 1,
		croppedImage: null,
		croppedAreaPixels: null,
		basecroppedImage: null,
		rotation: 0,
		imageSrc: '',
		inactivevisible: false,
		deletevisible: false,
		authKey: null,
		ProfileImage: null,
		loading: true,
		saveAllButton: false,
		deactivateAccountButton: false,
		deleteAccountButton: false,
		updateButton: false,
		userDetails: {},

		businessName: '',
		businessUrl: '',
		email: '',
		firstName: '',
		lastName: '',
		phone: '',
		companyName: '',
		userName: '',
		accessLevel: '',
	});

	const onFinish = async (value) => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();

		setState({
			...state,
			saveAllButton: true,
		});
		const request = {
			businessName: value.businessName || '',
			businessUrl: value.businessUrl || '',
			email: value.email || '',
			firstName: value.firstName || '',
			lastName: value.lastName || '',
			profileImage: state.basecroppedImage || '',
			phone: value.phone || '',
		};
		if (value && value.companyName) {
			request.companyName = value.companyName;
		}
		Axios.put(`${appConstant.domain + apiUrl.UPDATE_USER + authKey}`, request, { headers: { Authorization: authToken } })
			.then((res) => {
				setState({
					...state,
					saveAllButton: false,
				});
				if (res.data.success) {
					message.success('Profile updated successfully');
					window.location.reload(false);
				} else {
					message.error(res.data && res.data.messages && res.data.messages[0]);
				}
			})
			.catch((e) => {
				if (e.response) {
					message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
				setState({
					...state,
					saveAllButton: false,
				});
			});
	};

	const imageUpload = async () => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();

		setState({
			...state,
			uploadAllButton: true,
		});
		const request = {
			businessName: state.businessName || '',
			businessUrl: state.businessUrl || '',
			email: state.email || '',
			firstName: state.firstName || '',
			lastName: state.lastName || '',
			profileImage: state.basecroppedImage || '',
			phone: state.phone || '',
		};
		if (state && state.companyName) {
			request.companyName = state.companyName;
		}
		Axios.put(`${appConstant.domain + apiUrl.UPDATE_USER + authKey}`, request, { headers: { Authorization: authToken } })
			.then((res) => {
				setState({
					...state,
					saveAllButton: false,
					uploadAllButton: false,
				});
				if (res.data.success) {
					message.success('Image Uploaded successfully');
					window.location.reload(false);
				} else {
					message.error(res.data && res.data.messages && res.data.messages[0]);
				}
			})
			.catch((e) => {
				if (e.response) {
					message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
				setState({
					...state,
					saveAllButton: false,
					uploadAllButton: false,
				});
			});
	};

	const onUpload = async () => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();

		const request = {
			profileImage: state.basecroppedImage || '',
		};
		Axios.put(`${appConstant.domain + apiUrl.GET_USER + authKey}`, request, { headers: { Authorization: authToken } })
			.then((res) => {
				if (res.data.success) {
					message.success('Profile updated successfully');
				} else {
					message.error(res.data && res.data.messages && res.data.messages[0]);
				}
			})
			.catch((e) => {
				if (e.response) {
					message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
			});
	};

	const crop = (crp) => {};

	const zoom = (zoom) => {};

	const setZoom = (setZoom) => {};

	const setCrop = (setCrop) => {
		setState({
			...state,
			crop: setCrop,
		});
	};

	const onCropComplete = (croppedArea, croppedAreaPixels) => {
		new Promise((resolve) => {
			setState({
				...state,
				croppedAreaPixels: croppedAreaPixels,
			});
			resolve(croppedAreaPixels);
		}).then((croppedAreaPixels) => {
			getCrappedImage(croppedAreaPixels);
		});
	};

	const removeImage = () => {
		setState({ ...state, basecroppedImage: null, imageSrc: null });
	};

	const fileChange = async (files) => {
		message.warn('Please wait...');
		// if (files && files[0] && files[0].size / 1024 <= 1025) {
		// message.warn('Please wait while your image checks for nudity');
		let file = await files[0];
		// let isNudeValue = await isNude(file);
		let isNudeValue = false;
		if (!isNudeValue) {
			await setState({ ...state, imageSrc: window.URL.createObjectURL(file) });
		} else {
			message.error('Nudity and Partial Nudity images are not allowed');
		}
		// } else {
		// 	message.error('file size must be less than 1 mb');
		// }
	};

	const isNude = async (file) => {
		let base64 = await getBase64(file).then((res) => {
			return res;
		});
		const deepai = require('deepai');
		// OR include deepai.min.js as a script tag in your HTML
		// deepai.setApiKey('quickstart-QUdJIGlzIGNvbWluZy4uLi4K');
		deepai.setApiKey('fb333df1-33d2-406a-b75e-c88637c38354');
		var resp = await deepai.callStandardApi('nsfw-detector', {
			image: base64,
		});

		return (await resp.output.nsfw_score) > 0.5;
	};

	const getCrappedImage = async (croppedAreaPixels) => {
		try {
			const { croppedImage, basecroppedImage } = await getCroppedImg(state.imageSrc, croppedAreaPixels, state.rotation);
			setState({ ...state, croppedImage, basecroppedImage });
		} catch (e) {}
	};

	const clickInactive = () => {
		setState({ ...state, inactivevisible: true });
	};

	const clickDeleteAccount = () => {
		setState({ ...state, deletevisible: true });
	};

	const componentDidMount = async () => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();

		if (authKey) {
			setState({ ...state, authKey, authToken });
			getUserDetails();
		} else {
			history.push('/login');
		}
	};

	const getUserDetails = async () => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();
		Axios.get(`${appConstant.domain}${apiUrl.GET_USER}${authKey}`, { headers: { Authorization: authToken } })
			.then((res) => {
				if (res.data.success) {
					setState({
						...state,
						loading: false,
						accessLevel: (res.data.messages && res.data.messages.accessLevel) || '',
						profileImage: (res.data.messages && res.data.messages.profileImage) || '',
						imageSrc: (res.data.messages && res.data.messages.profileImage) || '',
						businessName: (res.data.messages && res.data.messages.businessName) || '',
						businessUrl: (res.data.messages && res.data.messages.businessUrl) || '',
						email: (res.data.messages && res.data.messages.email) || '',
						firstName: (res.data.messages && res.data.messages.firstName) || '',
						lastName: (res.data.messages && res.data.messages.lastName) || '',
						password: (res.data.messages && res.data.messages.password) || '',
						phone: (res.data.messages && res.data.messages.phone) || '',
						userId: (res.data.messages && res.data.messages.userId) || '',
						userName: (res.data.messages && res.data.messages.userName) || '',
						authKey: (res.data.messages && res.data.messages.authKey) || '',
						userStatus: (res.data.messages && res.data.messages.userStatus) || '',
					});
				} else {
					message.error(res.data && res.data.messages && res.data.messages[0]);
				}
			})
			.catch((e) => {
				setState({
					...state,
					loading: false,
				});
				if (e.response) {
					message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
			});
	};

	const deleteAccount = async () => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();

		setState({
			...state,
			deleteAccountButton: true,
		});
		Axios.delete(`${appConstant.domain}${apiUrl.DELETE_USER}${authKey}`, {
			headers: { Authorization: authToken },
		})
			.then((res) => {
				setState({
					...state,
					deleteAccountButton: false,
				});
				if (res.data.success) {
					removeUser(userDetails.authKey, history);
					localStorage.removeItem('authKey');
					localStorage.removeItem('messages');
					localStorage.removeItem('authToken');
					localStorage.removeItem('userDetails');
				} else {
					message.error(res.data && res.data.messages && res.data.messages[0]);
				}
			})
			.catch((e) => {
				setState({
					...state,
					deleteAccountButton: false,
					deletevisible: false,
				});
				message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
			});
	};

	const onFinishChangePassword = async (value) => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();
		value.authKey = authKey;
		if (value.newPassword.trim() === value.confirmPassword.trim()) {
			setState({
				...state,
				updateButton: true,
			});
			Axios.put(`${appConstant.domain}${apiUrl.RESET_CURRENT_PASSWORD}`, value, { headers: { Authorization: authToken } })
				.then((res) => {
					if (res.data.success) {
						setState({
							...state,
							updateButton: false,
						});
						message.success('Password changed successfully.. Please login with new password');
						window.location.reload();
						setProfileVisible(false);
					} else {
						setState({
							...state,
							updateButton: false,
						});
						message.error(res.data && res.data.messages && res.data.messages[0]);
					}
				})
				.catch((e) => {
					setState({
						...state,
						updateButton: false,
					});
					if (e.response) {
						message.error(
							(e.response.data && e.response.data.messages && e.response.data.messages[0]) ===
								`Error converting value "Could not authenticate user credentials. User not found" to type 'Affiliate.Models.ViewModels.AuthMessage'. Path 'message', line 1, position 85.`
								? appConstant.currentPasswordDoesNotMatch
								: appConstant.somethingWentWrong
						);
					}
				});
		} else {
			message.error('New and Confirmed password must match');
		}
	};

	const resetchangePswd = () => {
		setProfileVisible(false);
		try {
			if (formChangePasswordRef.current) {
				formChangePasswordRef.current.resetFields();
			}
		} catch (e) {}
	};

	const deactivatecccount = async () => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();

		setState({
			...state,
			deactivateAccountButton: true,
		});
		Axios.put(`${appConstant.domain}${apiUrl.DEACTIVATE_USER}${authKey}`, {
			headers: { Authorization: authToken },
		})
			.then((res) => {
				setState({
					...state,
					deactivateAccountButton: true,
				});
				if (res.data.success) {
					message.success('Account Deactivated..');
					localStorage.clear();
					history.push('/login');
				} else {
					message.error(res.data && res.data.messages && res.data.messages[0]);
				}
			})
			.catch((e) => {
				setState({
					...state,
					deactivateAccountButton: false,
					inactivevisible: false,
				});
				if (e.response) {
					message.error(e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
			});
	};

	useEffect(() => {
		componentDidMount();
	}, []);

	return (
		<ProfilePresentational
			onFinish={onFinish}
			profilevisible={profilevisible}
			setProfileVisible={setProfileVisible}
			clickDeleteAccount={clickDeleteAccount}
			clickInactive={clickInactive}
			getCrappedImage={getCrappedImage}
			onUpload={onUpload}
			crop={crop}
			zoom={zoom}
			setCrop={setCrop}
			setZoom={setZoom}
			onCropComplete={onCropComplete}
			removeImage={removeImage}
			fileChange={fileChange}
			deleteAccount={deleteAccount}
			onFinishChangePassword={onFinishChangePassword}
			resetchangePswd={resetchangePswd}
			deactivatecccount={deactivatecccount}
			state={state}
			formRef={formRef}
			imageUpload={imageUpload}
			userDetails={userDetails}
			handlechange={handlechange}
			formChangePasswordRef={formChangePasswordRef}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		removeUser: (authKey) => dispatch(ActionsApp.creators.removeUser(authKey)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(ProfileFunctional);

export default Connected;
